
import {
    VIRTUAL_LOCKER_LIST,
    VIRTUAL_LOCKER_LIST_FAIL,
    VIRTUAL_LOCKER_LIST_SUCCESS,
    VIRTUAL_LOCKER_STATUS_CHANGE,
    VIRTUAL_LOCKER_STATUS_CHANGE_FAIL,
    VIRTUAL_LOCKER_STATUS_CHANGE_SUCCESS,
} from "../../actions/admin/customer-actions";

const initialState = {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
    totalPages: 0,
    lockerStatistics:{},
    total: 0,
    recordList: [],
};

const lockerReducer = (state = initialState, { type, payload }) => {
    switch (type) {

        case VIRTUAL_LOCKER_LIST: {
            return {
                ...state,
                isLoading: true,
            };
        }

        case VIRTUAL_LOCKER_LIST_SUCCESS: {
            return {
                ...state,
                recordList: payload.data.data,
                lockerStatistics: payload.data.lockerCount,
                total: payload.data.total,
                totalPages: payload.data.totalPages,
                isLoading: false,
            };
        }

        case VIRTUAL_LOCKER_LIST_FAIL: {
            return {
                ...state,
                isLoading: false,
            };
        }

        case VIRTUAL_LOCKER_STATUS_CHANGE: {
            return {
                ...state,
                isLoading: true,
            };
        }

        case VIRTUAL_LOCKER_STATUS_CHANGE_SUCCESS: {
            const updated = payload?.data;
            if (updated?.id) {
                return {
                    ...state,
                    isLoading: false,
                    recordList: state.recordList.map((row) =>
                        row.id === updated.id
                            ? {
                                ...row,
                                ...updated,
                                status: updated.status,
                                locker_status: updated.locker_status ?? row.locker_status,
                                locker_expiry_date: updated.locker_expiry_date,
                                items_count:
                                    updated.items_count ?? row.items_count,
                            }
                            : row
                    ),
                };
            }
            return {
                ...state,
                isLoading: false,
            };
        }

        case VIRTUAL_LOCKER_STATUS_CHANGE_FAIL: {
            return {
                ...state,
                isLoading: false,
            };
        }

        default: {
            return { ...state };
        }
    }
};

export default lockerReducer;
